export const setFlags = 'Account/UpdateFlagBC';

export const FlagPrivacyPolicy = 'FlagPrivacyPolicy';
export const FlagB = 'FlagB';
export const FlagC = 'FlagC';
